/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    GetAllConfigurationTypesForDropDown,
    SaveConfiguration,
    GetAllConfigarationValues,
    DeleteConfigaration
};

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllConfigurationTypesForDropDown() {
    const response = await CommonGet('/api/Configuration/GetAllConfigarationTypes', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function SaveConfiguration(FormData) {
    const response = await CommonPost('/api/Configuration/SaveConfigurationValue', null, FormData);
    return response;
}

async function GetAllConfigarationValues(groupID, operationEntityID) {
    const response = await CommonGet('/api/Configuration/GetAllConfigarationValues', 'groupID=' + parseInt(groupID) + '&operationEntityID=' + parseInt(operationEntityID));
    return response.data;
}

async function DeleteConfigaration(FormData) {
    const response = await CommonPost('/api/Configuration/DeleteConfigaration', null, FormData);
    return response;
}